import { Fragment, useState } from 'react'

import SlidingPane from 'react-sliding-pane'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'
import PopoverPanel from 'Root/App/PopoverPanel'
import MenuCreateElements from 'Root/Component/MenuCreateElements'
import { useCurrentUserId } from 'lib/use-current-user-id'
import { useIsClient } from 'lib/use-is-client'

import Preload from './Preload'

library.add(faPlus)

const Create = () => {
  const [open, setOpen] = useState<boolean>(false)
  const [ready, setReady] = useState<boolean>(false)
  const userId = useCurrentUserId()
  const isClient = useIsClient()

  if (!isClient || !Boolean(userId)) {
    return null
  }

  return (
    <Fragment>
      <Preload />
      <Button
        onClick={() => setOpen(!open)}
        icon={<FontAwesomeIcon icon={['fas', 'plus']} />}
      >
        <Trans>Crea</Trans>
      </Button>
      <SlidingPane
        from="bottom"
        hideHeader
        isOpen={open}
        onRequestClose={() => setOpen(false)}
        onAfterOpen={() => setReady(true)}
        onAfterClose={() => setReady(false)}
        overlayClassName="z-30 w-screen"
        shouldCloseOnEsc
        width="100%"
      >
        <PopoverPanel showPanel={ready}>
          <MenuCreateElements
            onClose={() => setOpen(false)}
            onReady={setReady}
          />
        </PopoverPanel>
      </SlidingPane>
    </Fragment>
  )
}

export default Create
